webpackJsonp([207],{

/***/ 1323:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UsersMasTable_vue__ = __webpack_require__(3094);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6ab58998_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UsersMasTable_vue__ = __webpack_require__(5801);
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UsersMasTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6ab58998_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UsersMasTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1345:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = makeRule;
/*
 * 根据给定的多个文件路径引入模块
 * @Author: anker.wang
 * @Date: 2018-01-08 11:23:04
 * @Last Modified by: anker.wang
 * @Last Modified time: 2018-07-26 12:37:26
 */

/**
 * 快速制作验证规则
 * https://github.com/yiminghe/async-validator
 * @param {*} message
 * @param {*} type
 * @param {*} trigger
 * @param {*} required
 *
 string: Must be of type string. This is the default type.
 number: Must be of type number.
 boolean: Must be of type boolean.
 method: Must be of type function.
 regexp: Must be an instance of RegExp or a string that does not generate an exception when creating a new RegExp.
 integer: Must be of type number and an integer.
 float: Must be of type number and a floating point number.
 array: Must be an array as determined by Array.isArray.
 object: Must be of type object and not Array.isArray.
 enum: Value must exist in the enum.
 date: Value must be valid as determined by Date
 url: Must be of type url.
 hex: Must be of type hex.
 email: Must be of type email.
 */
function makeRule(message) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'string';
  var trigger = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'blur';
  var required = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

  var rule = { message: message, type: type, trigger: trigger, required: required };
  rule.transform = function (value) {
    // 为空字符串时转换为null
    value === '' && (value = null);
    // 数字类型忽略为null的数字转换
    if (value !== null && ['number', 'integer', 'float'].includes(type)) {
      value = Number(value);
    }
    return value;
  };
  return rule;
}

/***/ }),

/***/ 1347:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/*
 * ElementUI 日期选择组件的参数
 * @Author: anker.wang
 * @Date: 2018-01-08 11:27:07
 * @Last Modified by: anker.wang
 * @Last Modified time: 2018-01-08 11:28:27
 */

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      dateTimePickerOptions: {
        shortcuts: [{
          text: '一周后',
          onClick: function onClick(picker) {
            var date = new Date();
            date.setTime(date.getTime() + 3600 * 1000 * 24 * 7);
            picker.$emit('pick', date);
          }
        }, {
          text: '三天后',
          onClick: function onClick(picker) {
            var date = new Date();
            date.setTime(date.getTime() + 3600 * 1000 * 24 * 3);
            picker.$emit('pick', date);
          }
        }, {
          text: '明天',
          onClick: function onClick(picker) {
            var date = new Date();
            date.setTime(date.getTime() + 3600 * 1000 * 24);
            picker.$emit('pick', date);
          }
        }, {
          text: '今天',
          onClick: function onClick(picker) {
            picker.$emit('pick', new Date());
          }
        }, {
          text: '昨天',
          onClick: function onClick(picker) {
            var date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24);
            picker.$emit('pick', date);
          }
        }, {
          text: '三天前',
          onClick: function onClick(picker) {
            var date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24 * 3);
            picker.$emit('pick', date);
          }
        }, {
          text: '一周前',
          onClick: function onClick(picker) {
            var date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', date);
          }
        }]
      },
      dateTimePickerRangeOptions: {
        shortcuts: [{
          text: '最近1周',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近1个月',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近3个月',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近6个月',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近1年',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近2年',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 730);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近3年',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 1095);
            picker.$emit('pick', [start, end]);
          }
        }]
      }
    };
  }
});

/***/ }),

/***/ 1352:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1357), __esModule: true };

/***/ }),

/***/ 1357:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(234);
__webpack_require__(143);
module.exports = __webpack_require__(1358);


/***/ }),

/***/ 1358:
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(41);
var get = __webpack_require__(145);
module.exports = __webpack_require__(12).getIterator = function (it) {
  var iterFn = get(it);
  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
  return anObject(iterFn.call(it));
};


/***/ }),

/***/ 1455:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);

/*
 * ElementUI 下拉远程搜索
 * @Author: anker.wang
 * @Date: 2018-02-08 13:26:37
 * @Last Modified by: anker.wang
 * @Last Modified time: 2018-02-08 13:27:08
 */

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      selectLoading: false
    };
  },

  methods: {
    selectRemoteMethod: function selectRemoteMethod(query, request, callback, params) {
      var _this = this;

      if (query !== '') {
        this.selectLoading = true;
        setTimeout(function () {
          request(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ keyword: query }, params)).then(function (response) {
            callback(response.data);
          }).finally(function () {
            _this.selectLoading = false;
          });
        }, 200);
      } else {
        this.rawCustomerItems = [];
      }
    }
  }
});

/***/ }),

/***/ 1524:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__xlsx_v1__ = __webpack_require__(1525);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_filters__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);

/*
 * 表格页面的通用方法
 * @Author: anker.wang
 * @Date: 2018-01-08 11:25:59
 * @Last Modified by: anker.wang
 * @Last Modified time: 2018-04-25 11:53:19
 * @Description 路由参数自动同步到搜索参数;在路由更新时获得表格数据;使用分页和搜索事件自动变更路由
 */





/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      // 搜索表单字段
      search: {},
      // 搜索字段申明
      searchFieldType: {},
      // 表格数据
      table: [],
      // 分页参数
      pagination: {
        current_page: 1,
        per_page: 20,
        total: 1
      }
    };
  },

  // 路由进入时
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    // 在导航转入新的路由前
    next(function (vm) {
      // 处理路由参数
      var query = vm.handleSearchFieldType(to.query);
      // 设置搜索参数
      vm.setSearchParams(query);
      // 获取表格数据
      vm.handleTableDataRequest(query);
    });
  },

  // 路由更新时
  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
    // 处理路由参数
    var query = this.handleSearchFieldType(to.query);
    // 获取表格数据
    this.handleTableDataRequest(query);
    // 继续加载路由
    next();
  },

  methods: {
    /**
     * 获得表格数据
     * @param {*} params
     * @typedef 必须重写
     */
    getTableData: function getTableData(params) {
      // 需要重写该方法 返回 Promise 对象
    },

    /**
     * 设置表格数据
     * @param {*} params
     * @typedef 可选重写
     */
    setTableData: function setTableData(params) {
      this.table = params;
    },

    /**
     * 获得搜索参数的类型声明
     * @description 从路由上同步参数时会造成获得全部都是字符串
     * @typedef 可选重写
     */
    getSearchFieldType: function getSearchFieldType() {
      return this.searchFieldType;
    },

    /**
     * 获取分页数据
     * @param {*} params
     * @typedef 可选重写
     */
    getPagination: function getPagination() {
      return {
        current_page: this.pagination.current_page,
        per_page: this.pagination.per_page
      };
    },

    /**
     * 设置分页数据
     * @param {*} params
     * @typedef 可选重写
     */
    setPagination: function setPagination(pagination) {
      this.pagination.current_page = Number(pagination.current_page);
      this.pagination.per_page = Number(pagination.per_page);
      this.pagination.total = Number(pagination.total);
    },

    /**
     * 获得搜索参数
     * @description 会同步到路由的query参数中
     * @typedef 可选重写
     */
    getSearchParams: function getSearchParams() {
      return this.search;
    },

    /**
     * 设置搜索参数
     * @typedef 可选重写
     */
    setSearchParams: function setSearchParams(params) {
      for (var key in params) {
        if (this.search.hasOwnProperty(key)) {
          this.search[key] = params[key];
        }
      }
    },

    /**
     * 获得获得路由参数
     * @description
     * @typedef 可选重写
     */
    getRouterQueryParams: function getRouterQueryParams() {
      return this.handleSearchFieldType(this.$route.query);
    },

    /**
     * 设置路由参数
     * @description 设置路由参数
     * @typedef 可选重写
     */
    setRouterQueryParams: function setRouterQueryParams() {
      var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      this.$router.replace({
        query: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, query, {
          // 用于相同的搜索参数时也触发路由更新
          '-_-': __WEBPACK_IMPORTED_MODULE_3_moment___default()().format('HHmmss')
        })
      });
    },

    /**
     * 获得搜索表单的ref名称
     * @typedef 可选重写
     */
    getSearchFormRef: function getSearchFormRef() {
      return 'searchForm';
    },

    /**
     * 获得请求参数
     * 删除空数组以及空字段
     * @param {*} params
     */
    getRequestParams: function getRequestParams(params) {
      // 设定的搜索参数
      var searchParams = this.getSearchParams();
      // 请求参数
      var requestParams = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, searchParams, params);
      // 删除空的请求参数
      for (var key in requestParams) {
        // 为数组时必须长度大于0
        if (requestParams[key] instanceof Array && requestParams[key].length === 0) {
          delete requestParams[key];
        }
        // 空字符串或者null时删除字段
        if (requestParams[key] === '' || requestParams[key] === null) {
          delete requestParams[key];
        }
      }
      return requestParams;
    },

    /**
     * 设置请求参数到路由参数
     * 路由在改变参数以后会自动获得表格数据
     */
    setRequestParamsToRouter: function setRequestParamsToRouter(params) {
      // 获得分页参数
      var pagination = this.getPagination();
      // 获得所有请求参数
      var requestParams = this.getRequestParams();
      // 设置路由参数
      this.setRouterQueryParams(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, pagination, requestParams, params));
    },

    /**
     * 匹配到搜索参数的类型
     * 必须 search 中存在的字段，通过申明的类型转换
     * @param {*} query
     */
    handleSearchFieldType: function handleSearchFieldType(query) {
      var search = this.getSearchParams();
      var searchType = this.getSearchFieldType();
      var pagination = this.getPagination();
      var params = {};
      // 循环路由参数
      for (var key in query) {
        // 搜索参数
        if (search.hasOwnProperty(key) && query.hasOwnProperty(key)) {
          var value = query[key];
          // 是否存在类型声明
          if (value && searchType.hasOwnProperty(key)) {
            // 根据声明转换数据类型
            value = __WEBPACK_IMPORTED_MODULE_2__core_filters__["default"].dataTypeConve(value, searchType[key]);
          }
          params[key] = value;
        }
        // 分页参数
        if (pagination.hasOwnProperty(key) && query.hasOwnProperty(key)) {
          params[key] = Number(query[key]);
        }
      }
      return params;
    },

    /**
     * 处理表格数据请求
     * @param {*} params
     */
    handleTableDataRequest: function handleTableDataRequest(params) {
      var _this = this;

      params = this.handleRequestParams(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.getPagination(), this.getRequestParams(), params));
      // 获得表格数据
      this.getTableData(params).then(function (res) {
        _this.setTableData(res.data.data);
        _this.setPagination({
          current_page: res.data.current_page,
          per_page: res.data.per_page,
          total: res.data.total
        });
      });
    },

    /**
     * 对发送请求的参数进行处理
     * @param {*} params
     * @typedef 可选重写
     */
    handleRequestParams: function handleRequestParams(params) {
      return params;
    },

    /**
     * 处理分页大小时的变化
     * @param {*} val
     */
    handleSizePageChange: function handleSizePageChange(val) {
      var pagination = this.getPagination();
      if (pagination.per_page !== val) {
        pagination.per_page = val;
        this.setRouterQueryParams(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.getRouterQueryParams(), pagination));
      }
    },

    /**
     * 处理页码变化
     * @param {*} val
     */
    handleCurrentPageChange: function handleCurrentPageChange(val) {
      var pagination = this.getPagination();
      if (pagination.current_page !== val) {
        pagination.current_page = val;
        this.setRouterQueryParams(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.getRouterQueryParams(), pagination));
      }
    },

    /**
     * 搜索列表方法
     * @param {*} params
     */
    onSearch: function onSearch(params) {
      var _this2 = this;

      // 验证填写参数
      var searchForm = this.$refs[this.getSearchFormRef()];
      if (searchForm) {
        searchForm.validate(function (valid) {
          if (valid) {
            _this2.setRequestParamsToRouter(params);
          } else {
            _this2.$message.error('搜索内容填写不正确！');
          }
        });
      } else {
        this.setRequestParamsToRouter(params);
      }
    },

    /**
     * 重置表单方法
     */
    resetForm: function resetForm() {
      this.$refs[this.getSearchFormRef()].resetFields();
    },
    exportExcelFile: function exportExcelFile(name, request) {
      var _this3 = this;

      var fileName = __WEBPACK_IMPORTED_MODULE_1__xlsx_v1__["a" /* default */].makeName(name);
      this.$store.commit('VISIBLE_LAYOUT_EXPORT_DIALOG', true);
      this.$store.commit('SET_LAYOUT_EXPORT_NAME', fileName + '.xlsx');
      request.then(function (res) {
        __WEBPACK_IMPORTED_MODULE_1__xlsx_v1__["a" /* default */].exportFile(res.data.data, { fileName: fileName });
        _this3.$store.commit('SET_LAYOUT_EXPORT_PERCENTAGE', 100);
        _this3.$store.commit('SET_LAYOUT_EXPORT_STATUS', 'success');
      }).catch(function () {
        _this3.$store.commit('SET_LAYOUT_EXPORT_STATUS', 'exception');
      });
    },

    /**
     * 导出EXCEL文件
     * @param {*} name
     * @param {*} params
     */
    exportMoreExcelFile: function exportMoreExcelFile(name, params) {
      var self = this;
      var fileName = __WEBPACK_IMPORTED_MODULE_1__xlsx_v1__["a" /* default */].makeName(name);
      var _totalRow = 0;
      var _currentTotalRow = 0;
      var _params = this.handleRequestParams(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.getPagination(), this.getRouterQueryParams(), params));
      __WEBPACK_IMPORTED_MODULE_1__xlsx_v1__["a" /* default */].requestExportFile(this.getTableData, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, _params, params), {
        fileName: fileName,
        titles: { title: '标题' },
        ArrayObjects: true,
        onStart: function onStart(totalPage, totalRow) {
          _totalRow = totalRow;
          self.$store.commit('VISIBLE_LAYOUT_EXPORT_DIALOG', true);
          self.$store.commit('SET_LAYOUT_EXPORT_NAME', fileName + '-' + totalRow + '.xlsx');
        },
        onFinish: function onFinish(data) {
          self.$store.commit('SET_LAYOUT_EXPORT_STATUS', 'success');
        },
        onProgress: function onProgress(data, total) {
          _currentTotalRow += data.data.length;
          self.$store.commit('SET_LAYOUT_EXPORT_PERCENTAGE', Math.floor(_currentTotalRow / _totalRow * 100));
        },
        onError: function onError(error) {
          self.$store.commit('SET_LAYOUT_EXPORT_STATUS', 'exception');
          throw new Error(error);
        }
      });
    }
  }
});

/***/ }),

/***/ 1525:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_xlsx__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_xlsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_xlsx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_file_saver__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_file_saver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_file_saver__);

/*
 * excel文件的导出
 * @Author anker.wang
 * @Date: 2018-01-08 11:16:50
 * @Last Modified by: anker.wang
 * @Last Modified time: 2018-06-13 17:43:58
 */




function s2ab(s) {
  var buf = new ArrayBuffer(s.length);
  var view = new Uint8Array(buf);
  for (var i = 0; i !== s.length; ++i) {
    view[i] = s.charCodeAt(i) & 0xFF;
  }return buf;
}

/* harmony default export */ __webpack_exports__["a"] = ({
  /**
   * 转换对象列表转换为二维数组列表
   * [{}] => [[]]
   * @param {array} arrayObjects 数组对象
   * @param {array} keys 字段顺序列表，使转换后的值顺序保持一致
   * @returns {Array}
   * @constructor
   */
  ArrayObjectsToArrays: function ArrayObjectsToArrays(arrayObjects, keys) {
    var arrays = [];
    // 为数组且数组有内容
    if (arrayObjects && arrayObjects instanceof Array && arrayObjects.length) {
      // 获得标题行
      if (!(keys && keys.length)) {
        keys = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(arrayObjects[0]);
      }
      // 写入标题行
      arrays.push(keys);
      // 获得数据列
      arrayObjects.forEach(function (arrayObject) {
        var array = [];
        // 必须为对象
        if (arrayObject instanceof Object) {
          // 根据标题行顺序获取内容保障数组顺序
          keys.forEach(function (key) {
            array.push(arrayObject[key]);
          });
        }
        arrays.push(array);
      });
    }
    return arrays;
  },
  exportXlsx: function exportXlsx(arrays, options) {
    options.sheetName = options.sheetName || 'Sheet1';
    options.fileName = options.fileName || 'unnamed';
    var wb = {
      SheetNames: [],
      Sheets: {}
    };

    var ws = __WEBPACK_IMPORTED_MODULE_1_xlsx___default.a.utils.aoa_to_sheet(arrays);

    /* add worksheet to workbook */
    wb.SheetNames.push(options.sheetName);
    wb.Sheets[options.sheetName] = ws;

    /* bookType can be 'xlsx' or 'xlsm' or 'xlsb' or 'ods' */
    var wopts = { bookType: 'xlsx', bookSST: false, type: 'binary' };
    var wbout = __WEBPACK_IMPORTED_MODULE_1_xlsx___default.a.write(wb, wopts);

    /* the saveAs call downloads a file on the local machine */
    __WEBPACK_IMPORTED_MODULE_2_file_saver___default.a.saveAs(new Blob([s2ab(wbout)], { type: 'application/octet-stream' }), options.fileName + '.xlsx');
  }
});

/***/ }),

/***/ 1670:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export searchRules */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return searchMasRules; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return formRules; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return freezeFormRules; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return newUserConfigRules; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return newbieMissionConfigRules; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__ = __webpack_require__(1345);



var searchRules = {
  call_type: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请选择沟通类型', 'integer'))],
  communicate_detail: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请选择记录详情', 'integer'))],
  record_detail: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请选择沟通详情', 'string'))],
  communicate_type: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请选择沟通方式', 'integer'))]

};

var searchMasRules = {
  type: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请选择群发消息', 'integer'))],
  title: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入消息标题', 'string')), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('长度在1到30个字符'), { min: 1, max: 30 })],
  content: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入消息内容', 'string')), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('长度在1到300个字符'), { min: 1, max: 300 })]
};

var formRules = {
  cellphone: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入手机号', 'string'))]
};

var freezeFormRules = {
  freeze_status: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请选择封号状态', 'integer'))],
  freeze_reason: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请选择封号原因', 'integer'))],
  freeze_reason_desc: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入封号原因'))]

};

var newUserConfigRules = {
  condition_type: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请选择条件类型', 'string'))]
};

var newbieMissionConfigRules = {
  'watch_tutorial_video.video_url': [{ required: true, message: '请选择教程视频', trigger: 'change' }],
  'watch_tutorial_video.img_url': [{ required: true, message: '请上传教程视频封面', trigger: 'change' }],
  'finish_newbie_task.task_id': [{ required: true, message: '请选择一个新手任务', trigger: 'change' }]
};

/***/ }),

/***/ 3094:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(1352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_table_v1__ = __webpack_require__(1524);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__core_mixins_dateTimePicker__ = __webpack_require__(1347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__core_mixins_selectRemote__ = __webpack_require__(1455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__users_rules_js__ = __webpack_require__(1670);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_table_v1__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__core_mixins_dateTimePicker__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__core_mixins_selectRemote__["a" /* default */]],
  data: function data() {
    return {
      searchMasRules: __WEBPACK_IMPORTED_MODULE_6__users_rules_js__["e" /* searchMasRules */],
      dialogVisible: false,
      imgDialogVisible: false,
      masDetailVisible: false,
      formVisible: true,
      areaData: [],
      selectCitys: [],
      selectOptionName: null,
      // 表格数据
      table: [],
      selectLoading: false,
      // 分页参数
      pagination: {
        current_page: 1,
        per_page: 20,
        total: 0
      },
      masDetail: {
        masway: 1,
        title: null,
        content: null,
        img_title: null,
        img_url: [],
        link: null,
        sendTo: null
      },
      form: {
        masway: 1,
        area: [],
        areaString: '',
        markets: [],
        labels: [],
        title: null,
        content: null,
        img_title: null,
        // img: [],
        img_url: [],
        link: null
      },
      options: {
        masTypes: [{ id: 1, keyword: '全部用户' }, { id: 2, keyword: '选择地区' }, { id: 3, keyword: '选择超市' }, { id: 4, keyword: '选择标签' }],
        area: [],
        markets: [],
        labels: []
      },
      props: {
        label: 'name',
        value: 'id',
        children: 'cities'
      }
    };
  },

  computed: Vuex.mapState({}),
  created: function created() {
    this.getProvinceList();
  },

  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Vuex.mapActions(['getMasTable', 'getProvinceList', 'getCityList', 'getMarketInfo', 'uploadUserMasImg', 'getAreaList', 'getTagInfo']), {
    handleRemove: function handleRemove(file, fileList) {
      this.form.img_url = [];
    },

    /**
     * 获得表格数据
     * @param {*} params
     */
    getTableData: function getTableData(params) {
      return request.page('getMasTable', params);
    },
    handleItemChange: function handleItemChange(val) {
      var _this = this;

      // 如果加载过一遍不再重复加载
      var replaceArea = [];
      if (val.length === 1) {
        replaceArea = this.options.area;
      } else if (val.length === 2) {
        replaceArea = this.options.area[this.selectCitys[0]].cities;
      } else {
        return false;
      }
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(replaceArea)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var key = _step.value;

          if (replaceArea[key].id === val[val.length - 1]) {
            this.selectCitys[val.length - 1] = parseInt(key);
            if (val.length === 1) {
              this.selectOptionName = replaceArea[key].name;
              this.areaData = [];
              this.areaData.push(val[val.length - 1]);
            } else {
              this.selectOptionName = this.options.area[this.selectCitys[0]].name + '/' + replaceArea[key].name;
              this.areaData.splice(1, 1);
              this.areaData.push(val[1]);
            }
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      if (replaceArea[this.selectCitys[val.length - 1]].id === val[val.length - 1] && replaceArea[this.selectCitys[val.length - 1]].cities.length > 0) {
        return false;
      }
      if (val.length === 1) {
        request.common('getCityList', val[val.length - 1]).then(function (_ref) {
          var data = _ref.data;

          for (var i = 0; i < _this.options.area.length; i++) {
            if (_this.options.area[i].id === val[0]) {
              _this.options.area[i].cities = [];
              for (var n = 0; n < data.length; n++) {
                _this.options.area[i].cities.push({ id: data[n].id, name: data[n].name, cities: [] });
              }
            }
          }
        });
      } else if (val.length === 2) {
        request.common('getAreaList', val[val.length - 1]).then(function (_ref2) {
          var data = _ref2.data;

          if (data.length > 0) {
            for (var i = 0; i < _this.options.area[_this.selectCitys[0]].cities.length; i++) {
              _this.options.area[_this.selectCitys[0]].cities[i].cities = [];
              if (_this.options.area[_this.selectCitys[0]].cities[i].id === val[1]) {
                for (var n = 0; n < data.length; n++) {
                  _this.options.area[_this.selectCitys[0]].cities[i].cities.push({ id: data[n].id, name: data[n].name });
                }
              }
            }
          }
        });
      }
    },
    getProvinceList: function getProvinceList() {
      var _this2 = this;

      request.page('getProvinceList').then(function (_ref3) {
        var data = _ref3.data;

        for (var i = 0; i < data.length; i++) {
          _this2.options.area.push({ id: data[i].id, name: data[i].name, cities: [] });
        }
      });
    },
    handleItemSelect: function handleItemSelect(val) {
      if (val.length > 0) {
        this.areaData = val;
        var children = this.options.area[this.selectCitys[0]].cities[this.selectCitys[1]].cities;
        for (var i = 0; i < children.length; i++) {
          if (children[i].id === val[val.length - 1]) {
            this.selectOptionName = this.selectOptionName + '/' + children[i].name;
          }
        }
      }
    },
    onAddCity: function onAddCity() {
      if (this.selectOptionName === null) {
        this.$message.error('请选择地区后添加！');
        return false;
      }
      this.form.area.push(this.areaData[this.areaData.length - 1]);
      this.areaData = [];
      this.form.areaString += this.selectOptionName + ' ; ';
      this.selectCitys = [];
      this.selectOptionName = null;
    },
    onAddUserMas: function onAddUserMas() {
      var _this3 = this;

      this.formVisible = false;
      var detail = [];
      if (this.form.masway === 1) {
        detail = {
          masway: 1,
          title: this.form.title,
          content: this.form.content,
          img_title: this.form.img_title,
          img_url: this.form.img_url[0],
          link: this.form.link
        };
      } else if (this.form.masway === 2) {
        detail = {
          masway: 2,
          area: this.form.area,
          title: this.form.title,
          content: this.form.content,
          img_title: this.form.img_title,
          img_url: this.form.img_url[0],
          link: this.form.link
        };
        if (this.form.area.length <= 0) {
          this.$message.error('请至少选择一个地区');
          this.formVisible = true;
          return false;
        }
      } else if (this.form.masway === 3) {
        detail = {
          masway: 3,
          markets: this.form.markets,
          title: this.form.title,
          content: this.form.content,
          img_title: this.form.img_title,
          img_url: this.form.img_url[0],
          link: this.form.link
        };
        if (this.form.markets.length <= 0) {
          this.$message.error('请至少选择一个卖场');
          this.formVisible = true;
          return false;
        }
      } else if (this.form.masway === 4) {
        detail = {
          masway: 4,
          title: this.form.title,
          content: this.form.content,
          img_title: this.form.img_title,
          img_url: this.form.img_url[0],
          link: this.form.link,
          labels: this.form.labels
        };
        if (this.form.labels.length <= 0) {
          this.$message.error('请至少选择一个标签');
          this.formVisible = true;
          return false;
        }
      }
      this.$refs['form'].validate(function (valid) {
        if (valid) {
          return request.common('addUserMas', detail).then(function (data) {
            // this.form.img_url = []
            _this3.$refs['form'].resetFields();
            _this3.$refs.upload.clearFiles();
            _this3.onSearch();
            _this3.formVisible = true;
            _this3.dialogVisible = false;
            _this3.$message({
              showClose: true,
              message: '添加成功',
              type: 'success'
            });
          });
        } else {
          _this3.$message.error('提交内容填写不正确！');
          _this3.formVisible = true;
        }
      });
    },
    onRemoveCity: function onRemoveCity() {
      this.areaData = [];
      this.selectCitys = [];
      this.selectOptionName = null;
      this.form.area = [];
      this.form.areaString = '';
    },
    remoteMethod: function remoteMethod(query) {
      var _this4 = this;

      this.selectRemoteMethod(query, this.getMarketInfo, function (_ref4) {
        var data = _ref4.data;

        _this4.options.markets = data;
      });
    },
    remoteLabelMethod: function remoteLabelMethod(query) {
      var _this5 = this;

      this.selectRemoteMethod(query, this.getTagInfo, function (_ref5) {
        var data = _ref5.data;

        _this5.options.labels = data;
      });
    },
    onChangeFile: function onChangeFile(file, fileList) {
      var isExcel = file.raw.type === 'image/jpeg' || file.raw.type === 'image/png';
      var isLt10M = file.raw.size / 1024 / 1024 < 10;
      if (!isExcel) {
        this.$message.error('请上传jpg/jpeg/png图片!');
        this.$refs.upload.clearFiles();
        return false;
      }
      if (!isLt10M) {
        this.$message.error('大小不能超过10MB!');
        this.$refs.upload.clearFiles();
        return false;
      }
      this.OnUploadFile(file.raw);
    },
    OnUploadFile: function OnUploadFile(file) {
      var _this6 = this;

      var formData = new FormData();
      formData.append('pic', file);
      return request.common('uploadUserMasImg', formData).then(function (_ref6) {
        var data = _ref6.data;

        _this6.form.img_url = [];
        _this6.form.img_url.push(data);
        _this6.$message({
          showClose: true,
          message: '上传成功',
          type: 'success'
        });
      });
    },
    handlePictureCardPreview: function handlePictureCardPreview(file) {
      this.form.img = file.url;
      this.imgDialogVisible = true;
    },
    showDetail: function showDetail(row) {
      var _this7 = this;

      // 直接从前端列表里取，后端redis lrange存储不易取
      filter.setLoop(this.masDetail, row);
      this.$nextTick(function () {
        _this7.masDetailVisible = true;
      });
    }
  })
});

/***/ }),

/***/ 5801:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"title",rawName:"v-title",value:(_vm.$route.meta.title),expression:"$route.meta.title"}]},[_c('div',{staticClass:"page-heading"},[_c('h3',[_vm._v("\n      "+_vm._s(_vm.$route.meta.title)+"\n    ")]),_vm._v(" "),_c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},[_c('el-breadcrumb-item',{attrs:{"to":{ path: '/' }}},[_vm._v("首页")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v("用户管理")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v(_vm._s(_vm.$route.meta.title))])],1)],1),_vm._v(" "),_c('el-row',[_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){_vm.dialogVisible = true}}},[_vm._v("添加消息\n    ")]),_vm._v(" "),_c('br'),_c('br')],1),_vm._v(" "),_c('layout-panel',{attrs:{"show-header":false}},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.table,"stripe":"","highlight-current-row":""}},[_c('el-table-column',{attrs:{"prop":"id","label":"id"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"title","label":"消息标题"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',{staticStyle:{"cursor":"pointer","color":"rgb(88,157,248)"},on:{"click":function($event){return _vm.showDetail(scope.row)}}},[_vm._v(_vm._s(scope.row.title))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"masway","label":"发送方式"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return _vm._l((_vm.options.masTypes),function(value){return (value.id === scope.row.masway)?_c('span',[_vm._v(_vm._s(value.keyword))]):_vm._e()})}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"sendTo","label":"发送至"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"admin_name","label":"发送人"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"created_at","label":"发送时间"}})],1),_vm._v(" "),_c('div',{staticClass:"pagination"},[_c('el-pagination',{attrs:{"background":"","current-page":_vm.pagination.current_page,"page-sizes":[20, 50, 100, 200],"page-size":_vm.pagination.per_page,"layout":"total, sizes, prev, pager, next, jumper","total":_vm.pagination.total},on:{"size-change":_vm.handleSizePageChange,"current-change":_vm.handleCurrentPageChange}})],1)],1),_vm._v(" "),_c('el-dialog',{attrs:{"title":"群发消息","visible":_vm.dialogVisible,"width":"50%"},on:{"update:visible":function($event){_vm.dialogVisible=$event}}},[_c('el-form',{ref:"form",attrs:{"model":_vm.form,"label-width":"80px","size":"medium","rules":_vm.searchMasRules},nativeOn:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.onAddUserMas()}}},[_c('el-form-item',{attrs:{"label":"群发方式","prop":"masway"}},[_c('el-select',{attrs:{"placeholder":"请选择结算时间"},model:{value:(_vm.form.masway),callback:function ($$v) {_vm.$set(_vm.form, "masway", $$v)},expression:"form.masway"}},_vm._l((_vm.options.masTypes),function(masType,index){return _c('el-option',{key:index,attrs:{"label":masType.keyword,"value":masType.id}})}),1)],1),_vm._v(" "),(_vm.form.masway === 2)?[_c('el-form-item',{attrs:{"label":"添加地区","prop":"areaString"}},[_c('el-cascader',{attrs:{"options":_vm.options.area,"props":_vm.props,"value":_vm.areaData,"clearable":""},on:{"active-item-change":_vm.handleItemChange,"change":_vm.handleItemSelect}}),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","size":"mini"},on:{"click":function($event){return _vm.onAddCity()}}},[_vm._v("添加\n          ")]),_vm._v(" "),_c('el-button',{attrs:{"type":"danger","size":"mini"},on:{"click":function($event){return _vm.onRemoveCity()}}},[_vm._v("清空\n          ")]),_vm._v(" "),_c('el-input',{attrs:{"disabled":"","type":"textarea"},model:{value:(_vm.form.areaString),callback:function ($$v) {_vm.$set(_vm.form, "areaString", $$v)},expression:"form.areaString"}})],1)]:_vm._e(),_vm._v(" "),(_vm.form.masway === 3)?[_c('el-form-item',{attrs:{"label":"选择卖场","prop":"markets"}},[_c('el-select',{attrs:{"multiple":"","filterable":"","remote":"","reserve-keyword":"","placeholder":"请输入关键词","remote-method":_vm.remoteMethod,"loading":_vm.selectLoading},model:{value:(_vm.form.markets),callback:function ($$v) {_vm.$set(_vm.form, "markets", $$v)},expression:"form.markets"}},_vm._l((_vm.options.markets),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.marketname,"value":item.id}})}),1)],1)]:_vm._e(),_vm._v(" "),(_vm.form.masway === 4)?[_c('el-form-item',{attrs:{"label":"选择标签","prop":"labels"}},[_c('el-select',{attrs:{"multiple":"","filterable":"","remote":"","reserve-keyword":"","placeholder":"请输入关键词","remote-method":_vm.remoteLabelMethod,"loading":_vm.selectLoading},model:{value:(_vm.form.labels),callback:function ($$v) {_vm.$set(_vm.form, "labels", $$v)},expression:"form.labels"}},_vm._l((_vm.options.labels),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.tagname,"value":item.id}})}),1)],1)]:_vm._e(),_vm._v(" "),_c('el-form-item',{attrs:{"label":"消息标题","prop":"title"}},[_c('el-input',{attrs:{"placeholder":"(输入系统推送与站内信标题，限30字)"},model:{value:(_vm.form.title),callback:function ($$v) {_vm.$set(_vm.form, "title", $$v)},expression:"form.title"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"消息内容","prop":"content"}},[_c('el-input',{attrs:{"type":"textarea","autosize":"","placeholder":"(输入消息内容,限300字)"},nativeOn:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }$event.stopPropagation();}},model:{value:(_vm.form.content),callback:function ($$v) {_vm.$set(_vm.form, "content", $$v)},expression:"form.content"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"添加图片","prop":"img_url"}},[_c('el-upload',{ref:"upload",attrs:{"limit":1,"on-change":_vm.onChangeFile,"list-type":"picture-card","on-remove":_vm.handleRemove,"on-preview":_vm.handlePictureCardPreview,"action":"","auto-upload":false}},[_c('i',{staticClass:"el-icon-plus"})]),_vm._v(" "),_c('el-dialog',{attrs:{"visible":_vm.imgDialogVisible},on:{"update:visible":function($event){_vm.imgDialogVisible=$event}}},[_c('img',{attrs:{"width":"100%","src":_vm.form.img,"alt":"爱零工"}})])],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"图片标题","prop":"img_title"}},[_c('el-input',{attrs:{"placeholder":"(输入图片标题，限30字)"},model:{value:(_vm.form.img_title),callback:function ($$v) {_vm.$set(_vm.form, "img_title", $$v)},expression:"form.img_title"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"链接地址","prop":"link"}},[_c('el-input',{attrs:{"placeholder":"(输入链接地址)"},model:{value:(_vm.form.link),callback:function ($$v) {_vm.$set(_vm.form, "link", $$v)},expression:"form.link"}})],1)],2),_vm._v(" "),_c('span',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[(_vm.formVisible)?_c('el-button',{attrs:{"type":"primary","size":"mini"},on:{"click":function($event){return _vm.onAddUserMas()}}},[_vm._v("发送")]):_vm._e(),_vm._v(" "),_c('el-button',{attrs:{"size":"mini"},on:{"click":function($event){_vm.dialogVisible = false}}},[_vm._v("取 消")])],1)],1),_vm._v(" "),_c('el-dialog',{attrs:{"title":"群发消息详情","visible":_vm.masDetailVisible,"width":"50%"},on:{"update:visible":function($event){_vm.masDetailVisible=$event}}},[_c('el-form',{ref:"formDetail",attrs:{"model":_vm.masDetail,"label-width":"80px","size":"medium"}},[_c('el-form-item',{attrs:{"label":"消息标题","prop":"title"}},[_vm._v(_vm._s(_vm.masDetail.title)+"\n      ")]),_vm._v(" "),_c('el-form-item',{attrs:{"label":"消息内容","prop":"content"}},[_vm._v(_vm._s(_vm.masDetail.content)+"\n      ")]),_vm._v(" "),_c('el-form-item',{attrs:{"label":"发送图片","prop":"img_url"}},[(_vm.masDetail.img_url)?_c('a',{attrs:{"href":_vm.masDetail.img_url,"target":"_Blank"}},[_c('img',{attrs:{"width":"100px;","src":_vm.masDetail.img_url?_vm.masDetail.img_url+'?x-oss-process=image/resize,w_100/auto-orient,1':null,"alt":"爱零工"}})]):_vm._e()]),_vm._v(" "),_c('el-form-item',{attrs:{"label":"图片标题","prop":"img_title"}},[_vm._v(_vm._s(_vm.masDetail.img_title)+"\n      ")]),_vm._v(" "),_c('el-form-item',{attrs:{"label":"链接地址","prop":"link"}},[_vm._v(_vm._s(_vm.masDetail.link)+"\n      ")]),_vm._v(" "),_c('el-form-item',{attrs:{"label":"发送方式","prop":"masway"}},_vm._l((_vm.options.masTypes),function(masType){return (masType.id === _vm.masDetail.masway )?_c('span',[_vm._v("\n          "+_vm._s(masType.keyword)+"\n        ")]):_vm._e()}),0),_vm._v(" "),_c('el-form-item',{attrs:{"label":"发送至","prop":"type"}},[_vm._v(_vm._s(_vm.masDetail.sendTo)+"\n      ")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/users-mas.3fb3b73cad34e9435e26.js